/**
 * Created by Administrator on 2017/5/4.
 */
// 导航插件
import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import './index.less';
import airplaneICon from '../assets/flight.png';
import airplaneICon2 from '../assets/flight2.png';

class Nav extends PureComponent {
  render() {
    const {lang} =this.props;
    return (
      <div className="navBox" style={{ marginTop: '-2px' }}>
        <div
          ref="navBarHeight"
          className={`navbar_nav ${this.props.navStyle}`}
          style={{ float: 'left' }}
        >
          <div className="navbar_line">
            {this.props.navStyle !== 'nav3' && (
              <img
                style={
                  this.props.navStyle == 'nav2'
                    ? { left: '70%' }
                    : { left: '30%' }
                }
                alt=""
                src={airplaneICon2}
              />
            )}
            <div className="navbar_lineLeft">
              <div className="lineLeft_cont">
                <span className="line" />
                <span className="sc" />
              </div>
              <span className="navbar_tips1"> {lang.fillInfo}</span>
            </div>
            <div className="lefts">
              <div className="line_" />
              {this.props.navStyle !== 'nav1' ? (
                <div className="line_" />
              ) : (
                <div className="line" />
              )}
            </div>
            <div className="navbar_lineCenter">
              <div className="lineCenter_cont">
                {this.props.navStyle !== 'nav1' ? (
                  <div className="line_f" />
                ) : (
                  <div className="line" />
                )}
                {this.props.navStyle !== 'nav1' ? (
                  <div className="_line_" />
                ) : (
                  <div className="line_" />
                )}
                {this.props.navStyle == 'nav1' ? (
                  <span className="nextC" />
                ) : (
                  <span className="next" />
                )}
              </div>
              <span
                className="navbar_tips2"
                style={
                  this.props.navStyle !== 'nav1'
                    ? { color: 'rgba(0, 138, 203, 1)' }
                    : { color: 'rgba(38, 38, 38, 0.6)' }
                }
              >
                {' '}
                {lang.as15}
              </span>
            </div>
            <div className="rights">
              {this.props.navStyle !== 'nav1' ? (
                <div className="line_" />
              ) : (
                <div className="line" />
              )}
              {this.props.navStyle == 'nav3' ? (
                <div className="line_" />
              ) : (
                <div className="line" />
              )}
              {/* <div className='line'></div> */}
            </div>
            <div className="navbar_lineRight">
              <div className="lineRight_cont">
                <span className="line" />
                {this.props.navStyle == 'nav3' ? (
                  <span className="line_" />
                ) : (
                  <span className="line" />
                )}
                {this.props.navStyle == 'nav3' ? (
                  <span className="nextCF" />
                ) : (
                  <span className="nextC" />
                )}
              </div>
              <span
                className="navbar_tips3"
                style={
                  this.props.navStyle == 'nav3'
                    ? { color: 'rgba(0, 138, 203, 1)' }
                    : { color: 'rgba(38, 38, 38, 0.6)' }
                }
              >
                {' '}
                {lang.updateDetail86}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Nav.PropTypes = {
  navStyle: PropTypes.string,
  lang: PropTypes.object,
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav/index.js